<template>
  <div class="info-create">
    <el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="100px">
      <!-- <el-form-item label="标题名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入标题名称" class="input" />
      </el-form-item>-->
      <el-form-item label="商场" prop="selectedRange">
        <el-select v-model="form.selectedRange" placeholder="请选择商场" @change="onMallChange" multiple filterable collapse-tags>
          <el-option label="全部" value="ALL"></el-option>
          <el-option
            v-for="(item, index) in mallOption"
            :label="item.name"
            :value="item.id"
            :key="index"
            :disabled="form.selectedRange.indexOf('ALL') >= 0"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="序号" prop="sort">
        <el-input
          oninput="value=value.replace(/[^\d]/g,'')"
          v-model="form.sort"
          placeholder="请输入序号"
          class="input"
        />
      </el-form-item>
      <el-form-item label="封面图" prop="image">
        <UploadImg @getUploadFile="(file)=>{ this.form.image = file }" :uploadUrl="form.image" :desc="'建议：上传375*99的jpg、 png的图片'"> </UploadImg>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-select v-model="form.type" placeholder="请选择类型" @change="typeChange">
          <el-option label="富文本" value="text"></el-option>
          <el-option label="链接" value="url"></el-option>
          <el-option label="小程序跳转" value="miniprogram"></el-option>
        </el-select>
      </el-form-item>
      <div v-if="form.type == 'url'">
        <el-form-item label="跳转链接" prop="type">
          <el-radio-group v-model="form.urlType">
            <el-radio :label="true">内部链接</el-radio>
            <el-radio :label="false">外部链接</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label prop="url" :rules="[{ required: true, message: '请输入跳转链接'}]">
          <el-input placeholder="请输入连接" v-model="form.url" class="input">
            <template v-if="form.urlType?false:true" slot="prepend">Https://</template>
          </el-input>
        </el-form-item>
      </div>
      <div v-if="form.type == 'miniprogram'">
        <el-form-item label="" prop="appId">
          <el-input v-model="form.appId" placeholder="请输入appid" class="input" ></el-input>
      </el-form-item>
      <el-form-item label="" prop="url">
          <el-input v-model="form.url" placeholder="请输入跳转链接" class="input"></el-input>
      </el-form-item>
      </div>
      <el-form-item label="详情" prop="detail" v-if="form.type == 'text'">
        <div style="border: 1px solid #ccc; margin-top: 10px;width: calc(100% - 40px);">
          <!-- 工具栏 -->
          <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="toolbarConfig"
          />
          <!-- 编辑器 -->
          <Editor
            style="height: 600px; overflow-y: hidden;"
            :defaultConfig="editorConfig"
            v-model="form.detail"
            @onCreated="onCreated"
          />
        </div>
      </el-form-item>
      <el-form-item label="状态" prop="condition">
        <el-radio-group v-model="form.enable">
          <el-radio :label="true">启用</el-radio>
          <el-radio :label="false">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click="onBack" class="fun-btn mr20">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="onSubmit" class="fun-btn">确定</el-button>
    </div>
  </div>
</template>

<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import editor from "@/mixins/editor";
import UploadImg from "@/components/UploadImg/index";
import { api_getInfo, api_putInfo, api_postInfo } from "@/api/info";
import { api_postFileUpload, api_getConfig } from "@/api/common";
export default {
  name: "infoCreate",
  mixins: [editor],
  components: {
    UploadImg,
    Editor,
    Toolbar
  },
  data() {
    return {
      form: {
        type: "text",
        url: "",
        selectedRange:[],
        name: "",
        image: "",
        detail: "",
        sort: "",
        urlType:true,
        enable: true,
        appId:''
      },
      mallOption: [],
      rules: {
        selectedRange: [{ required: true, message: "请选择商场" }],
        // name: [{ required: true, message: '请输入标题名称' }],
        image: [{ required: true, message: "请上传封面图" }],
        detail: [{ required: true, message: "请输入详情" }],
        url: [{ required: true, message: "请输入跳转链接" }],
        appId:[{ required: true, message: "请输入appid" }],
        sort: [{ required: true, message: "请输入序号" }]
      },
      submitLoading: false
    };
  },
  created() {
    if (this.$route.query.id) {
      this.$route.meta.breadcrumbTitle =
        '<span class="noblack">服务配置/信息专栏<span class="black">/编辑信息</span></span>';
      this.getInfo();
    } else {
      this.$route.meta.breadcrumbTitle =
        '<span class="noblack">服务配置/信息专栏<span class="black">/创建信息</span></span>';
    }
    this.getConfigData();
  },
  methods: {
    // 获取config数据（商场、店铺级联框）
    async getConfigData() {
      let { mall } = await api_getConfig(["mall"]);
      mall.forEach(item => item.id = item.id + '')
      this.mallOption = mall;
    },

    // 商场下拉框改变
    onMallChange(data) {
      if (data.indexOf('ALL') >= 0) {
        this.form.selectedRange = ['ALL']
      }
    },

    // 点击提交按钮
    onSubmit() {
      if (this.form.detail == "<p><br></p>") {
        this.form.detail = "";
      }
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          let mallName = this.mallOption.filter(item => this.form.selectedRange.includes(item.id))
          let params = {
            ...this.form,
            selectedRange: this.form.selectedRange.join(','),
            mallName: this.form.selectedRange.indexOf('ALL') >= 0 ? '全部' : (mallName.map(item => item.name)).join(',')
          };
          try {
            if (this.form.image.size) {
              const { key } = await api_postFileUpload(
                this.form.image,
                "InfoImg"
              );
              params.image = key;
            }
            params.enable = params.enable ? 1 : 0;
            params.urlType ? params.urlType = 'base' : params.urlType = 'out'
            params.type=='url'&&params.urlType == 'out'&& !params.url.startsWith("https://")?params.url = 'https://'+params.url:params.url
            switch (params.type) {
              case 'url':
                delete params.detail
                delete params.appId
              break;
              case 'text':
                delete params.url
                delete params.appId
              break;
              case 'miniprogram':
                delete params.detail
              break;
              default:
                break;
            }
            this.$route.query.id
              ? await api_putInfo({ ...params, id: this.$route.query.id })
              : await api_postInfo(params);
            this.$baseMessage("操作成功", "success");
            this.onBack();
            this.submitLoading = false;
          } catch (err) {
            console.log('err: ', err);
            this.submitLoading = false;
          }
        }
      });
    },
    typeChange(){
      this.form.url = ''
      this.form.appId = ''
      this.form.detail = ''
      this.$refs.form.clearValidate();
    },
     // 字符串截取
    sliceString(str, prefix) {
      if (str.indexOf(prefix) === 0) {
        return str.slice(prefix.length);
      }
      return str;
    },
    // 获取详情数据
    async getInfo() {
      const data = await api_getInfo({ id: this.$route.query.id });
      let { selectedRange, name, image, detail, sort, enable, url, type,urlType,appId } = data;
      urlType === 'base'?urlType=true:urlType=false
      enable === 1?enable=true:enable=false
      selectedRange = selectedRange ? selectedRange.split(',') : []
      url = url?this.sliceString(url,'https://'):''
      appId = appId?appId:''
      this.form = { selectedRange, name, image, detail, sort, enable, url, type ,urlType,appId };
    },
    // 返回
    onBack() {
      this.$router.back(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.info-create {
  width: 100%;
  padding-top: 20px;
  box-sizing: border-box;
  position: relative;
  padding-bottom: 100px;
  .el-input,
  .el-textarea,
  .el-select {
    width: 350px;
  }

  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
    position: absolute;
    left: 350px;
    bottom: 0;
  }

  .optional {
    height: 17px;
    line-height: 17px;
    margin-top: 5px;
    font-size: 12px;
    color: #666666;
  }
  ::v-deep {
    .avatar-uploader {
      height: 152px;
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
  }
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
